export default __webpack_public_path__ + "static/media/linkedin-incon__grey.29cebfe0.svg";